import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom';
import IconVerify from '../../assets/email-verification-icon.svg';
import IconEmailVerify from '../../assets/icon-email-verif.svg';
import IconPhoneVerify from '../../assets/icon-phone-verify.svg';
import IconReg from '../../assets/icon-registration.svg';
import CustomAlert from '../../components/CustomAlert';
import config from '../../config/Constant';
import { postRequest } from '../../helpers/apiHandler';
import { setLoginSuccess, onLogout } from '../../store/actions/reduxAction';
import { ResendEmailModal } from './ResendEmailModal';
import { clearSignupForm } from '../../store/actions/reduxAction';

const baseUrl = process.env.PUBLIC_URL;

const AccountActivation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { active, role, signup_email } = useSelector((state) => ({
    active: state.auth.user.active,
    role: state.auth.user.role,
    signup_email: state.signup.email
  }));

  const params = useParams()
  const [show, setShow] = useState(false);
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  useEffect(() => {
    activateUserAccount()
    return () => {
    };
  }, []);

  const handleLogout = () => {
    dispatch(onLogout());
    localStorage.clear();
    navigate('/login');
  };


  const activateUserAccount = () => {
    const { token } = params;

    if (role === 'admin') return navigate('/admin/dashboard')
    if (active) return navigate(`/phone/verify/${token}`)

    if (token) {
      postRequest('/auth/activate-account', {}, token, res => {
        if (res.success) {
          dispatch(setLoginSuccess(res));
          navigate(`/phone/verify/${token}`);
          // Clear signup form, because at this point, the email should be the correct email used
          dispatch(clearSignupForm());
        }
      });
    }
    if (!token) {
      setAlertState({
        message: 'Invalid Token',
        show: true,
        variant: 'danger',
      });
      return;
    }
  };


  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div className="Authenticate AccountActivation">
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <ResendEmailModal
        show={show}
        onHide={setShow}
      />
      <div className="account-activation-wrapper">
        <div className="account-activation">
          <div className="account-activation-step">
            <div className="account-activation-step-item">
              <img src={IconReg} alt="..." />
              <div>Registration</div>
            </div>
            <div className="divider-line" />
            <div className="account-activation-step-item active-item">
              <img src={IconEmailVerify} alt="..." />
              <div>Email Verification</div>
            </div>
            <div className="divider-line" />
            <div className="account-activation-step-item">
              <img src={IconPhoneVerify} alt="..." />
              <div>Mobile Verification</div>
            </div>
          </div>
          <img alt="..." src={IconVerify} />
          <h3>
            Thank You for Joining! Please Verify Your
            <br />
            Email
          </h3>
          <p>
            Before we get started, we need to verify your email address first. We've sent
            <br />
            the verification link to <strong>{signup_email}</strong>. Don't forget to check your spam/
            <br />
            junk folder as well.
          </p>
          <div className="divider-line" style={{ width: '100%' }} />
          <p>
            If you haven’t received the email click&nbsp;
            <Button
              variant="link"
              onClick={() => setShow(true)}
            >
              Resend verification email.
            </Button>

            <br /><br />
            If the email you entered is wrong <Link to={`${baseUrl}/signup`}>Sign Up</Link> Again.
          </p>
          <div>
            <button className="dropdown-item dropdown-item-logout" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt mr-2" />
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};


export default AccountActivation;
